import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * Delete View Confirmation Dialog component
 * Confirms deletion of a tab/view before removing it
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {Function} props.onOpenChange - Callback when dialog open state changes
 * @param {string} props.viewName - Name of the view to delete
 * @param {Function} props.onConfirm - Callback when deletion is confirmed
 * @returns {JSX.Element} Delete View Confirmation Dialog
 */
export default function DeleteViewDialog({
  open,
  onOpenChange,
  viewName,
  onConfirm,
}) {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-md max-w-[90vw]'>
        <DialogHeader>
          <DialogTitle className='text-lg font-semibold text-foreground'>
            Delete View
          </DialogTitle>
        </DialogHeader>
        <div className='py-4'>
          <p className='text-sm text-foreground break-words'>
            Are you sure you want to delete the view{" "}
            <span className='font-medium break-all'>"{viewName}"</span>? This
            action cannot be undone.
          </p>
        </div>
        <DialogFooter className='flex flex-row justify-end gap-2'>
          <Button
            onClick={handleConfirm}
            className='font-light text-sm bg-red-600 text-white hover:bg-red-700'>
            Delete
          </Button>
          <Button
            variant='outline'
            onClick={() => onOpenChange(false)}
            className='font-light text-sm border-border text-foreground hover:bg-muted'>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
